
import { Component, Mixins, Prop, Watch } from "vue-property-decorator";
import { formMixin, formOptionsMixin, formValidationMixin } from "../mixins";
import Select from "./Select.vue";
import { getModule } from "vuex-module-decorators";
import BarcodeItemTypeModule from "@/store/modules/barcodeSystem/itemType";
import { ItemTypeResource } from "@/models/api/barcodeSystem/itemTypes/get";

const barcodeItemTypeModuleState = getModule(BarcodeItemTypeModule);

@Component({
  components: {
    Select
  }
})
export default class ItemTypeSelect extends Mixins(
  formMixin,
  formOptionsMixin,
  formValidationMixin
) {
  @Prop({ default: false })
  appendToBody: boolean;
  @Prop()
  type: string;
  @Prop({ default: null })
  companyIds: number[];
  localItemTypes: ItemTypeResource[] = null;

  get itemTypes()
  {
    return barcodeItemTypeModuleState.itemTypes;
  }

  created() {
    this.localItemTypes = JSON.parse(JSON.stringify(this.itemTypes));
  }

  get types() {
    if(this.companyIds && this.companyIds.length > 0)
      return this.localItemTypes.filter(x => x.companyIds.some(y => this.companyIds.includes(y))).map(x => ({ label: x.itemTypeValue, value: x.itemTypeValue }));
    else
      return this.localItemTypes.map(x => ({ label: x.itemTypeValue, value: x.itemTypeValue }));
  }
}
